__turbopack_context__.v({
  "alert": "_2lAebq_alert",
  "alertContent": "_2lAebq_alertContent",
  "alertIcon": "_2lAebq_alertIcon",
  "alertText": "_2lAebq_alertText",
});
